<template>
  <div class="post-wall-card">
    <PostWallCardTop :postCardTopData="postCardTopData"></PostWallCardTop>
    <PostWallCardContent :postCardContentData="postCardContentData"></PostWallCardContent>
    <div v-if="postData.ReplyCount > 0" class="reply-count" @click="openChildDialog()">{{ postData.ReplyCount }} 則留言</div>
    <hr class="la-hr" />
    <PostWallCardBottom ref="postWallCardBottom" v-if="postData.ShareObj" :postCardBottomData="postCardBottomData"></PostWallCardBottom>
  </div>
</template>

<script>
import PostWallCardTop from '@/components/PostWall/PostWallCard/PostWallCardTop';
import PostWallCardContent from '@/components/PostWall/PostWallCard/PostWallCardContent';
import PostWallCardBottom from '@/components/PostWall/PostWallCard/PostWallCardBottom';
export default {
  name: 'PostWallCard',
  components: { PostWallCardTop, PostWallCardContent, PostWallCardBottom },
  props: ['postData'],
  computed: {
    // 貼文卡片上方區塊需要的資料
    postCardTopData() {
      return {
        CanDelete: this.postData.CanDelete,
        PostId: this.postData.PostId,
        DiffranceTime: this.postData.DiffranceTime,
        LikeCount: this.postData.LikeCount,
        MemObj: this.postData.MemObj,
        Visible: this.postData.Visible,
        TagNicknameList: this.postData.TagNicknameList,
        TagAvatarList: this.postData.TagAvatarList,
        ShareTagAvatarList: this.postData.ShareTagAvatarList,
        ShareTagNicknameList: this.postData.ShareTagNicknameList
      };
    },
    // 貼文卡片中間需要的資料
    postCardContentData() {
      return {
        Content: this.postData.Content,
        ShareObj: this.postData.ShareObj,
        imgSet: this.postData.imgSet,
        HasSharePost: this.postData.HasSharePost
      };
    },
    // 貼文卡片下方區塊需要的資料
    postCardBottomData() {
      return {
        TargetId: this.postData.PostId,
        PostId: this.postData.PostId,
        LikeIt: this.postData.LikeIt,
        LikeCount: this.postData.LikeCount,
        HasSharePost: this.postData.HasSharePost
      };
    }
  },
  methods: {
    // 開啟子元件裡的 dialog
    openChildDialog() {
      this.$refs.postWallCardBottom.openDialog();
    }
  }
};
</script>

<style lang="scss" scoped>
.post-wall-card {
  padding: 18px;
  padding-bottom: 0;
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(196, 196, 196, 0.25);
  margin-bottom: 12px;
}

.la-hr {
  border: 1px dashed $LaleSeparatorLine;
  margin: 15px 0 0 0;
}

.reply-count {
  text-align: right;
  margin: 15px 0;
  color: $LaleGray8;
}

// 當是被分享到別人貼文下的貼文會有不一樣的 UI
.share-card {
  .post-wall-card {
    padding: 0;
    background-color: #fff;
    box-shadow: none;
    margin-bottom: 12px;
  }

  .la-hr {
    display: none;
  }
}
// share-card END --------------------------
</style>
